import React from "react";
import { injectIntl } from "react-intl";
import { MessageMood, StatusMessage } from "@trainline/depot-web";
import * as styles from "./SplitSaveAlert.module.css";
const SplitSaveAlert = ({
  requiresSeatChange,
  stationToChange,
  intl
}) => /* @__PURE__ */ React.createElement("div", {
  className: styles.container
}, /* @__PURE__ */ React.createElement(StatusMessage, {
  mood: MessageMood.INFO,
  body: intl.formatMessage({
    id: requiresSeatChange ? "splitSaveAlert.switchTicketAndSeat" : "splitSaveAlert.switchTicket"
  }, { stationName: stationToChange })
}));
var SplitSaveAlert_default = injectIntl(SplitSaveAlert);
export {
  SplitSaveAlert_default as default
};
